import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Reusable back button.
 *  - Defaults to browser-history back (navigate(-1)) so it returns to the
 *    actual previous page, not a hardcoded path.
 *  - Pass `to` only if you specifically need to override the destination.
 *  - Pass `label="Back"` to show a text label next to the icon.
 */
const BackButton = ({ to, onClick, label = null, className = "" }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="Back"
      className={`inline-flex items-center gap-1.5 px-2 py-1.5 text-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded transition-colors ${className}`}
    >
      <ArrowLeft size={16} className="shrink-0" />
      {label && <span>{label}</span>}
    </button>
  );
};

export default BackButton;
